import { useState } from 'react';
import { categoryMap } from '../../../constants/dating';
import { useRouteContext } from '../../../context';
import { categoryMapProps } from '../interface';

export const useGetSelectedCategory = () => {
    const { parsedValues } = useRouteContext();

    const initialCategory =
        categoryMap.find(
            (category) => category.searchParam === parsedValues?.category,
        ) ?? categoryMap[0];

    const [categoryTag, setCategoryTag] = useState<categoryMapProps>(
        initialCategory as categoryMapProps,
    );

    return { categoryTag, setCategoryTag };
};
